import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { HBox, VBox } from '../../../../components/Box';
import { FormField } from '../../../../components/FormFields';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { Button } from '../../../../components/Buttons';
import { CompanyWorkflowsOverviewTable } from './CompanyWorkflowsOverviewTable';
import styled from 'styled-components';
import { fetchWorkflows } from '../../../Workflows/actions';
import { selectWorkflows } from '../../../Workflows/selectors';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_WORKFLOWS } from '../../../Workflows/constants';
import { Loader } from '../../../../components/Loader';
import { selectCompanyWorkflows } from '../../selectors';
import { addWorkflowToCompany, getCompanyWorkflows } from '../../actions';
import { REQUEST_ADD_COMPANY_WORKFLOW, REQUEST_COMPANY_WORKFLOWS, REQUEST_REMOVE_COMPANY_WORKFLOW } from '../../constants';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { changeWorkflowFilter } from '../../../Workflows/actions';

const Container = styled.div`
  width: 100%;
  max-width: 600px;
  background: white;
  .basic-multi-select {
    width: 100%;
    max-width: 100%;
  }
  .field-block {
    margin: 4px 0;
  }
`;

class WorkflowsSectionDetailsComp extends BaseComponent {
  componentDidMount() {
    this.props.getCompanyWorkflows();
    this.props.setWorkflowLimit(1000);
    this.props.fetchWorkflows();
  }

  get attachedWorkflows() {
    return this.props.attachedWorkflows ?? [];
  }

  get availableWorkflows() {
    const workflows = this.props.availableWorkflows;
    const attachedWorkflowsIds = this.attachedWorkflows.map(w => w.id);

    return workflows.filter(w => !attachedWorkflowsIds.includes(w.id));
  }

  get workflowOptions() {
    return this.availableWorkflows.map(p => {
      return { value: p.id, label: p.name };
    });
  }

  get onClickAddNewWorkflowDisabled() {
    return !this.state.newWorkflow?.value;
  }

  setNewWorkflow(e) {
    const { value } = e;
    const workflow = this.workflowOptions.find(w => w.value === value);
    this.setState({ newWorkflow: workflow });
  }

  onClickAddNewWorkflow() {
    this.props.addWorkflowToCompany(this.state.newWorkflow?.value);
  }

  render() {
    if (this.work) return <Loader small />;

    return (
      <Container>
        <VBox>
          <HBox left vBottom>
            <HBox className="field-block">
              <FormField label={this.lbl('company.details.workflowSelect')}>
                <SearchSelect
                  value={this.newWorkflow}
                  options={this.workflowOptions}
                  onChange={this.setNewWorkflow.bind(this)}
                />
              </FormField>
            </HBox>

            <Button small onClick={this.onClickAddNewWorkflow.bind(this)} disabled={this.onClickAddNewWorkflowDisabled}>
              {this.lbl('workflows.details.addNewProductBtn')}
            </Button>
            {this.props.editCompany && (
              <Button
                small
                primary
                onClick={() => {
                  this.props.history.push('/workflows', { state: { editCompanyId: this.props.company_id } });
                }}
              >
                {this.lbl('workflows.details.addNewWorkflowBtn')}
              </Button>
            )}
          </HBox>
          <CompanyWorkflowsOverviewTable workflows={this.props.attachedWorkflows} company_id={this.props.company_id} />
        </VBox>
      </Container>
    );
  }
}

WorkflowsSectionDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    availableWorkflows: selectWorkflows(),
    work: selectWorks([
      REQUEST_WORKFLOWS,
      REQUEST_COMPANY_WORKFLOWS,
      REQUEST_ADD_COMPANY_WORKFLOW,
      REQUEST_REMOVE_COMPANY_WORKFLOW,
    ]),
    attachedWorkflows: selectCompanyWorkflows(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchWorkflows() {
      dispatch(fetchWorkflows(0, 1000));
    },
    setWorkflowLimit(limit) {
      dispatch(changeWorkflowFilter('limit', limit));
    },
    addWorkflowToCompany(workflowId) {
      dispatch(addWorkflowToCompany(ownProps.company_id, workflowId));
    },
    getCompanyWorkflows() {
      if (ownProps.company_id) dispatch(getCompanyWorkflows(ownProps.company_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowsSectionDetails = compose(withConnect, withRouter)(WorkflowsSectionDetailsComp);
